import { z } from 'zod';

// Common field validators
export const emailSchema = z.string().email('Invalid email address').toLowerCase().trim();

export const passwordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .max(128, 'Password must be less than 128 characters')
  .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
  .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
  .regex(/[0-9]/, 'Password must contain at least one number');

export const slugSchema = z
  .string()
  .min(2, 'Slug must be at least 2 characters')
  .max(50, 'Slug must be less than 50 characters')
  .regex(/^[a-z0-9-]+$/, 'Slug can only contain lowercase letters, numbers, and hyphens')
  .toLowerCase()
  .trim();

export const uuidSchema = z.string().uuid('Invalid UUID');

export const dateStringSchema = z.string().datetime({ offset: true }).or(z.string().date());

export const phoneSchema = z
  .string()
  .regex(/^\+?[1-9]\d{1,14}$/, 'Invalid phone number')
  .optional()
  .nullable();

export const currencyCodeSchema = z.string().length(3, 'Currency code must be 3 characters');

export const timezoneSchema = z.string().min(1, 'Timezone is required');

// Pagination
export const paginationSchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  pageSize: z.coerce.number().int().positive().max(100).default(20),
});

// Sort
export const sortSchema = z.object({
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).default('asc'),
});

// Search
export const searchSchema = z.object({
  search: z.string().max(100).optional(),
});

// Combined list params
export const listParamsSchema = paginationSchema.merge(sortSchema).merge(searchSchema);

export type PaginationInput = z.infer<typeof paginationSchema>;
export type SortInput = z.infer<typeof sortSchema>;
export type ListParamsInput = z.infer<typeof listParamsSchema>;
